import { axiosInstance } from "api/axios";
import type { IUser } from "api/user/types";
import type { AuthUser } from "store/ducks/investor/slice";
import { PERMISSIONS, TYPE_LOGIN } from "utils/constant";

export interface AuthenticatedRouteSession {
	type: string;
	permissions: string[];
	profile: AuthUser;
}

type AuthProfilePayload = Omit<Partial<IUser>, "id"> & {
	id?: string | number;
	token?: unknown;
	accessToken?: unknown;
	refreshToken?: unknown;
};

type AuthProfile = AuthProfilePayload & { user?: AuthProfilePayload };

export const sanitizeAuthProfile = (profile: AuthProfile): AuthUser => {
	const authProfile = profile.user ?? profile;
	const { token: _token, accessToken: _accessToken, refreshToken: _refreshToken, ...safeProfile } =
		authProfile;
	return {
		...safeProfile,
		id: authProfile.id === undefined ? undefined : String(authProfile.id),
	};
};

const getServerPermissions = (profile: AuthProfile): string[] => {
	const permissions = profile?.permissions ?? profile?.user?.permissions ?? [];
	return Array.isArray(permissions) ? permissions : [];
};

export const getAuthenticatedRouteSession = async (): Promise<AuthenticatedRouteSession | null> => {
	try {
		const profile = (await axiosInstance.get("/profile")) as AuthProfile;
		const permissions = getServerPermissions(profile);
		const type = permissions.includes(PERMISSIONS.WEB_ISSUER_AUTHORIZE)
			? TYPE_LOGIN.issuer
			: TYPE_LOGIN.investor;

		return { type, permissions, profile: sanitizeAuthProfile(profile) };
	} catch (error) {
		return null;
	}
};
